import { ABServiceClient } from '@zocdoc/ab';
import { get } from 'lodash';
import cookies from 'js-cookie';
import { sanitizeId } from '../config/ab/util';
import getAwsApiHost from '../utils/getAwsApiHost';

const abClient = new ABServiceClient({
    basePath: getAwsApiHost(),
    fetch: fetchWithRetries,
    timeoutInMillis: 5000,
});

export const constructConversionsBody = action => {
    const conversionId = action.abMetric;
    const url = get(action, 'meta.analytics.page');
    const bsid = cookies.get('bsid');
    const sessionId = sanitizeId(bsid);
    const trackingId = cookies.get('firstTimeVisitor');
    const { userAgent } = navigator;
    return {
        conversionData: {
            conversions: [
                {
                    conversionId,
                    sessionId,
                    visitorIdType: 'sessionId',
                },
                {
                    conversionId,
                    trackingId,
                    visitorIdType: 'trackingId',
                },
            ],
            requestOriginUrl: url,
            userAgent,
        },
    };
};

export const trackAbConversionInOptimizely = action => {
    if (typeof window !== 'undefined' && action.abMetric) {
        abClient.trackConversion(constructConversionsBody(action));
    }
};

export const abConversionMiddleware = () => next => action => {
    trackAbConversionInOptimizely(action);

    return next(action);
};
